import API_BASE_URL from '../config';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateArticle = () => {
    const params = useParams();
    const navigate = useNavigate();

    // Core States
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState("Casual");
    const [fabricType, setFabricType] = useState("");
    const [dupattaType, setDupattaType] = useState("");
    const [season, setSeason] = useState("Winter");
    
    const [fabric, setFabric] = useState(0);
    const [work, setWork] = useState(0);
    const [stiching, setStiching] = useState(0);
    const [dupatta, setDupatta] = useState(0);
    const [misc, setMisc] = useState(0);
    const [salePrice, setSalePrice] = useState(0);

    const [isKidsArticle, setIsKidsArticle] = useState(false);
    const [isPublic, setIsPublic] = useState(false);
    const [isFeatured, setIsFeatured] = useState(false);
    
    const [photos, setPhotos] = useState([]); // Array of Base64 strings
    const [isDragging, setIsDragging] = useState(false);
    const [promotionEntries, setPromotionEntries] = useState([
        { cost: "", date: "", description: "", from: "" }
    ]);

    useEffect(() => {
        getArticleDetail();
    }, []);

    const getArticleDetail = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/article/${params.id}`);
            if (!result.ok) throw new Error("Failed to fetch");
            result = await result.json();

            if (result) {
                setName(result.name || "");
                setDescription(result.description || "");
                setCategory(result.category || "Casual");
                setFabricType(result.fabricType || "");
                setDupattaType(result.dupattaType || "");
                setSeason(result.season || "Winter");
                
                setFabric(result.fabric || 0);
                setWork(result.work || 0);
                setStiching(result.stiching || 0);
                setDupatta(result.dupatta || 0);
                setMisc(result.misc || 0);
                setSalePrice(result.salePrice || 0);

                setIsKidsArticle(result.articletype || false);
                setIsPublic(result.isPublic || false);
                setIsFeatured(result.isFeatured || false);
                setPhotos(result.photos || []);

                if (result.promotions && result.promotions.length > 0) {
                    const formattedPromos = result.promotions.map(p => ({
                        cost: p.cost || "",
                        date: p.date ? p.date.split('T')[0] : "",
                        description: p.description || "",
                        from: p.from || ""
                    }));
                    setPromotionEntries(formattedPromos);
                }
            }
        } catch (error) {
            console.error("Error loading article data:", error);
        }
    };

    // Handle multiple image conversion
    const handleImageChange = (files) => {
        if (!files) return;
        const fileArray = Array.from(files);
        if (photos.length + fileArray.length > 11) {
            alert("Maximum 11 photos allowed per article.");
            return;
        }

        fileArray.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPhotos(prev => [...prev, reader.result]);
            };
            reader.readAsDataURL(file);
        });
    };

    const removePhoto = (index) => {
        setPhotos(photos.filter((_, i) => i !== index));
    };

    const onDragOver = (e) => { e.preventDefault(); setIsDragging(true); };
    const onDragLeave = () => setIsDragging(false);
    const onDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        handleImageChange(e.dataTransfer.files);
    };

    const handlePromotionChange = (index, field, value) => {
        const updatedEntries = [...promotionEntries];
        updatedEntries[index][field] = value;
        setPromotionEntries(updatedEntries);
    };

    const addPromotionField = () => {
        setPromotionEntries([...promotionEntries, { cost: "", date: "", description: "", from: "" }]);
    };

    const removePromotionField = (index) => {
        const updatedEntries = promotionEntries.filter((_, i) => i !== index);
        setPromotionEntries(updatedEntries.length ? updatedEntries : [{ cost: "", date: "", description: "", from: "" }]);
    };

    const handleUpdate = async (event) => {
        event.preventDefault();
        
        const updateData = {
            name,
            description,
            category,
            fabricType,
            dupattaType,
            season,
            fabric: Number(fabric),
            work: Number(work),
            stiching: Number(stiching),
            dupatta: Number(dupatta),
            misc: Number(misc),
            salePrice: Number(salePrice),
            articletype: isKidsArticle,
            isPublic,
            isFeatured,
            photos,
            promotions: promotionEntries.filter(p => p.cost || p.date || p.from)
        };

        try {
            const response = await fetch(`${API_BASE_URL}/update-article/${params.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updateData)
            });

            if (response.ok) {
                alert("✅ Article Updated Successfully!");
                navigate('/articles');
            } else {
                alert("❌ Update failed.");
            }
        } catch (error) {
            alert("❌ Server Error: Could not connect to the backend.");
        }
    };

    const totalProductionCost = Number(fabric) + Number(work) + Number(stiching) + Number(dupatta) + Number(misc);

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    {/* PAGE HEADER */}
                    <div className="d-flex align-items-center mb-4">
                        <button className="btn btn-white shadow-sm rounded-circle me-3 border" onClick={() => navigate('/articles')}>←</button>
                        <h2 className="fw-bold mb-0">Update <span className="text-primary">Article</span></h2>
                        
                        <div className="ms-auto d-flex align-items-center">
                            <label className="fw-bold me-2 mb-0" style={{ cursor: 'pointer', color: isKidsArticle ? '#0d6efd' : '#6c757d' }}>
                                {isKidsArticle ? "👶 Kids Article" : "Standard Article"}
                            </label>
                            <div className="form-check form-switch mb-0">
                                <input 
                                    className="form-check-input shadow-none" 
                                    type="checkbox" 
                                    role="switch" 
                                    checked={isKidsArticle}
                                    onChange={(e) => setIsKidsArticle(e.target.checked)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card shadow-sm border-0 p-4">
                        <form onSubmit={handleUpdate}>
                            
                            {/* MEDIA SECTION */}
                            <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">🖼️ Photos ({photos.length}/11)</h5>
                            <div className="mb-4">
                                <div 
                                    onDragOver={onDragOver}
                                    onDragLeave={onDragLeave}
                                    onDrop={onDrop}
                                    className={`border border-2 rounded-3 d-flex flex-column align-items-center justify-content-center p-4 transition-all ${isDragging ? 'border-primary bg-light' : 'border-dashed text-muted bg-white'}`}
                                    style={{ borderStyle: 'dashed', minHeight: '120px', cursor: 'pointer' }}
                                    onClick={() => document.getElementById('imageInput').click()}
                                >
                                    <i className="bi bi-images fs-2"></i>
                                    <p className="mb-0 text-center">Drag & Drop Multiple Images or Click to Change</p>
                                    <input type="file" id="imageInput" className="d-none" multiple accept="image/*" onChange={(e) => handleImageChange(e.target.files)} />
                                </div>

                                {photos.length > 0 && (
                                    <div className="d-flex flex-wrap gap-2 mt-3">
                                        {photos.map((p, i) => (
                                            <div key={i} className="position-relative">
                                                <img src={p} alt="preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' }} />
                                                <button type="button" onClick={() => removePhoto(i)} className="btn btn-danger btn-sm position-absolute top-0 end-0 py-0 px-1" style={{ fontSize: '10px' }}>✖</button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* COST PREVIEW */}
                            <div className="p-3 mb-4 rounded bg-primary bg-opacity-10 border border-primary-subtle text-center">
                                <small className="text-primary fw-bold text-uppercase d-block">Ready Cost (Production)</small>
                                <h3 className="fw-bold text-primary mb-0">₹{totalProductionCost}</h3>
                            </div>

                            {/* BASIC INFO */}
                            <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">📋 Details & Settings</h5>
                            <div className="row g-3 mb-4">
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input className="form-control bg-light border-0" value={name} onChange={(e)=>setName(e.target.value)} placeholder="Name" required />
                                        <label>Article Name</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea className="form-control bg-light border-0" value={description} onChange={(e)=>setDescription(e.target.value)} placeholder="Description" style={{ height: '100px' }}></textarea>
                                        <label>Public Description</label>
                                    </div>
                                </div>
                            </div>

                            {/* CATEGORIZATION */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-3">
                                    <div className="form-floating">
                                        <select className="form-select bg-light border-0" value={category} onChange={(e)=>setCategory(e.target.value)}>
                                            <option value="Casual">Casual</option>
                                            <option value="Festive">Festive</option>
                                        </select>
                                        <label>Category</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-floating">
                                        <input className="form-control bg-light border-0" value={fabricType} onChange={(e)=>setFabricType(e.target.value)} placeholder="Fabric" />
                                        <label>Fabric Type</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-floating">
                                        <input className="form-control bg-light border-0" value={dupattaType} onChange={(e)=>setDupattaType(e.target.value)} placeholder="Dupatta" />
                                        <label>Dupatta Type</label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-floating">
                                        <select className="form-select bg-light border-0" value={season} onChange={(e)=>setSeason(e.target.value)}>
                                            <option value="Winter">Winter</option>
                                            <option value="Summer">Summer</option>
                                        </select>
                                        <label>Season</label>
                                    </div>
                                </div>
                            </div>

                            {/* PRICING GRID */}
                            <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">💰 Pricing & Costing</h5>
                            <div className="row g-2 mb-4">
                                <div className="col-md-2 col-6"><div className="form-floating"><input type="number" className="form-control bg-light border-0" value={fabric} onChange={(e)=>setFabric(e.target.value)} /><label>Fabric</label></div></div>
                                <div className="col-md-2 col-6"><div className="form-floating"><input type="number" className="form-control bg-light border-0" value={work} onChange={(e)=>setWork(e.target.value)} /><label>Work</label></div></div>
                                <div className="col-md-2 col-6"><div className="form-floating"><input type="number" className="form-control bg-light border-0" value={stiching} onChange={(e)=>setStiching(e.target.value)} /><label>Stiching</label></div></div>
                                <div className="col-md-2 col-6"><div className="form-floating"><input type="number" className="form-control bg-light border-0" value={dupatta} onChange={(e)=>setDupatta(e.target.value)} /><label>Dupatta</label></div></div>
                                <div className="col-md-2 col-6"><div className="form-floating"><input type="number" className="form-control bg-light border-0" value={misc} onChange={(e)=>setMisc(e.target.value)} /><label>Misc</label></div></div>
                                <div className="col-md-2 col-6">
                                    <div className="form-floating">
                                        <input type="number" className="form-control bg-primary text-white border-0" value={salePrice} onChange={(e)=>setSalePrice(e.target.value)} />
                                        <label className="text-white">Sale Price</label>
                                    </div>
                                </div>
                            </div>

                            {/* WEBSITE CONTROLS */}
                            <div className="d-flex gap-4 mb-4 p-3 bg-light rounded">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="publicToggle" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} />
                                    <label className="form-check-label fw-bold" htmlFor="publicToggle">Show on Website</label>
                                </div>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="featureToggle" checked={isFeatured} onChange={(e) => setIsFeatured(e.target.checked)} />
                                    <label className="form-check-label fw-bold" htmlFor="featureToggle">Featured Article</label>
                                </div>
                            </div>

                            {/* PROMOTIONS */}
                            <div className="mt-4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6 className="fw-bold text-secondary mb-0">📢 Promotion History</h6>
                                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={addPromotionField}>+ Add Row</button>
                                </div>
                                {promotionEntries.map((entry, index) => (
                                    <div key={index} className="row g-1 mb-1 align-items-center">
                                        <div className="col-md-2"><input type="date" className="form-control form-control-sm bg-light border-0" value={entry.date} onChange={(e) => handlePromotionChange(index, "date", e.target.value)} /></div>
                                        <div className="col-md-2"><input type="number" className="form-control form-control-sm bg-light border-0" placeholder="Cost" value={entry.cost} onChange={(e) => handlePromotionChange(index, "cost", e.target.value)} /></div>
                                        <div className="col-md-3"><input type="text" className="form-control form-control-sm bg-light border-0" placeholder="Source" value={entry.from} onChange={(e) => handlePromotionChange(index, "from", e.target.value)} /></div>
                                        <div className="col-md-4"><input type="text" className="form-control form-control-sm bg-light border-0" placeholder="Desc" value={entry.description} onChange={(e) => handlePromotionChange(index, "description", e.target.value)} /></div>
                                        <div className="col-md-1 text-end"><button type="button" className="btn btn-sm text-danger" onClick={() => removePromotionField(index)}>✖</button></div>
                                    </div>
                                ))}
                            </div>

                            {/* ACTIONS */}
                            <div className="d-grid gap-2 mt-4">
                                <button className="btn btn-primary py-3 fw-bold shadow-sm" type="submit">Update Article Details</button>
                                <button type="button" className="btn btn-light text-muted py-2 border-0" onClick={() => navigate('/articles')}>Discard Changes</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateArticle;